import { cubicBezier } from 'framer-motion';

export const containerCollapsingAnimation = {
  // This prevents the heading and icons from showing underneath the card below this one
  overflow: 'hidden',
  height: 0,
  paddingTop: 0,
  paddingBottom: 0,
  marginTop: 0,
  marginBottom: 0,
  transition: {
    duration: 0.8,
    ease: cubicBezier(0.25, 0.1, 0.25, 1),
    // this needs to be immediately set so that the overflow takes effect instantly
    overflow: { duration: 0 },
  },
};

const buildEnterAnimation = ({
  yOffset,
  timeOffset,
}: {
  yOffset: number;
  timeOffset: number;
}) => ({
  initial: { opacity: 0, y: 150 + yOffset },
  animate: {
    opacity: 1,
    y: 0,
    transition: { delay: 0.2, duration: 0.5 + timeOffset },
  },
});

export const enterFromBottomAnimations = {
  heading: buildEnterAnimation({ yOffset: 40, timeOffset: 0.15 }),
  subHeading: buildEnterAnimation({ yOffset: 30, timeOffset: 0.1 }),
  actions: buildEnterAnimation({ yOffset: 0, timeOffset: 0 }),
  icons: buildEnterAnimation({ yOffset: 150, timeOffset: 0.2 }),
  container: {
    animate: { height: '180px', transition: { duration: 0.4 } },
  },
  card: {
    // when content animates upwards, we do not want it to show over other content
    initial: { overflow: 'hidden' },
    animate: { height: '180px', transition: { duration: 0.4 } },
  },
};
